import { Box, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const PublicProfileLinksHeader = styled(Box)(({ theme }) => ({
  borderBottom: theme.palette.type === 'dark' ? `1px solid ${COLORS.DARK_BORDER}` : `1px solid ${COLORS.LIGHT_BORDER}`,
  paddingBottom: '20px',
}));
